export default __webpack_public_path__ + "static/media/Oil2Gas_02.6dd461fa.png";